module.exports = __webpack_public_path__ + "static/img/Game.9741221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse/Game.jpg
// module id = 1761
// module chunks = 0